export class ChartColor {
    constructor(public name:string, public color:string) {}
}


// WEBPACK FOOTER //
// ./src/app/assessment-charts/models/chart-color.ts